export default __webpack_public_path__ + "static/media/screen_google_calendar_06.1c441100.png";